import { AutoMap } from '@automapper/classes';
import { Permissions } from './permissions';

export class Role {
    @AutoMap()
    Name: string = '';
    @AutoMap()
    Permissions: Permissions[] = [];

}
